'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseCategoryModal', ['$scope', '$uibModalInstance', 'LicenseCategories', function ($scope, $uibModalInstance, LicenseCategories) {
        $scope.license_category = {};
        $scope.saving = false;

        LicenseCategories.get().then(function (categories) {
            $scope.license_category.sort_order = Math.max.apply(Math, categories.map(function (category) { return category.sort_order; })) + 1;
        })

        $scope.save = function () {
            $scope.saving = true;
            LicenseCategories.save($scope.license_category).then(function (newCategory) {
                $scope.saving = false;
                $uibModalInstance.close(newCategory);
            })
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;